/* Lorelia Sammlungsseiten (lr-sammlung, Nachtbau 28.09.2026)
   - Chips + Sortierung: weicher Wechsel per Section Rendering (?section_id=lr-sammlung), Rückfall = normaler Link
   - „Mehr laden“: nächste Seite holen, Karten ploppen nach (Rückfall = ?page=N)
   - Karten: gestaffeltes Aufploppen (IntersectionObserver, einmalig), zweites Bild nur bei Bedarf laden
     (Desktop beim Überfahren, Handy sanft automatisch, nur sichtbare Karten)
   - Alte Links ?kat=foto|poster|schmuck auf „Alle Geschenke“ werden auf die Chip-Ansicht umgeleitet */
(function () {
  'use strict';
  var root = document.querySelector('[data-lrs]');
  if (!root || root.__lrs) return;
  root.__lrs = true;

  var ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var maus = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cache = new Map();
  var stand = 0;

  /* ---------- Holen ---------- */
  function sectionUrl(href) {
    var u = new URL(href, location.href);
    u.hash = '';
    u.searchParams.set('section_id', 'lr-sammlung');
    try {
      if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && !u.searchParams.has('preview_theme_id')) u.searchParams.set('preview_theme_id', Shopify.theme.id);
    } catch (e) {}
    return u.toString();
  }
  function parse(text) {
    var d = new DOMParser().parseFromString(text, 'text/html');
    var n = d.querySelector('[data-lrs]');
    if (!n) throw new Error('keine Sammlung');
    return n;
  }
  function holen(href) {
    var key = sectionUrl(href);
    if (cache.has(key)) return cache.get(key);
    var p = fetch(key, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(parse)
      .catch(function () { /* Rückfall: ganze Seite holen */
        return fetch(href, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(parse);
      })
      .catch(function (e) { cache.delete(key); throw e; });
    if (cache.size > 24) cache.delete(cache.keys().next().value);
    cache.set(key, p);
    return p;
  }
  function vorladen(href) { try { holen(href).catch(function () {}); } catch (e) {} }

  /* ---------- Eintritt ---------- */
  var io = (!ruhig && 'IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    var n = 0;
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target; io.unobserve(el);
      el.style.setProperty('--d', Math.min(n++, 7) * 70 + 'ms');
      el.classList.add('da');
      if (maus && el.classList.contains('lrs-k')) nebenbei(function () { zweitesBild(el); });
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 }) : null;

  function beobachten() {
    root.querySelectorAll('.lrs-k:not(.da):not(.sofort), .lrs-zwischen:not(.da)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('da');
    });
    var mk = root.querySelector('[data-lrs-mehr]'); if (mk && ioMehr) ioMehr.observe(mk);
    root.querySelectorAll('.lrs-k.sofort').forEach(function (el) { if (maus) nebenbei(function () { zweitesBild(el); }); });
    if (io2) root.querySelectorAll('.lrs-k:not([data-auto])').forEach(function (el) {
      if (!el.querySelector('.lrs-b2')) return;
      el.setAttribute('data-auto', ''); io2.observe(el);
    });
  }
  /* Nächste Seite schon holen, wenn „Mehr laden“ in die Nähe kommt – dann ploppen die Karten sofort nach */
  var ioMehr = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { ioMehr.unobserve(e.target); vorladen(e.target.href); } });
  }, { rootMargin: '900px 0px' }) : null;
  function nebenbei(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 400); })(fn, { timeout: 2500 }); }

  /* ---------- Zweites Bild ---------- */
  function zweitesBild(k) {
    var img = k && k.querySelector('.lrs-b2');
    if (!img) return Promise.reject();
    if (img.__p) return img.__p;
    img.__p = new Promise(function (ok, nein) {
      img.onload = function () { k.classList.add('hat2'); ok(); };
      img.onerror = nein;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src || '';
      if (img.complete && img.naturalWidth) { k.classList.add('hat2'); ok(); }
    });
    return img.__p;
  }
  root.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var k = e.target.closest && e.target.closest('.lrs-k');
    if (k) zweitesBild(k).catch(function () {});
    var c = e.target.closest && e.target.closest('[data-lrs-chip]');
    if (c) vorladen(c.href);
  });
  root.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest('[data-lrs-chip]');
    if (c) vorladen(c.href);
  }, { passive: true });

  /* Handy: nacheinander bei sichtbaren Karten sanft auf das zweite Bild wechseln und zurück */
  var sicht = new Set();
  var io2 = (!maus && !ruhig && 'IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) sicht.add(e.target); else { sicht.delete(e.target); } });
  }, { threshold: 0.7 }) : null;
  if (io2) {
    setInterval(function () {
      if (document.hidden || !sicht.size) return;
      var wahl = null;
      sicht.forEach(function (k) {
        if (!k.isConnected) { sicht.delete(k); return; }
        if (k.classList.contains('zeigt2')) return;
        if (!wahl || (k.__t || 0) < (wahl.__t || 0) || ((k.__t || 0) === (wahl.__t || 0) && (wahl.compareDocumentPosition(k) & 2))) wahl = k;
      });
      if (!wahl) return;
      var k = wahl; k.__t = Date.now();
      zweitesBild(k).then(function () {
        if (!sicht.has(k)) return;
        k.classList.add('zeigt2');
        setTimeout(function () { k.classList.remove('zeigt2'); }, 3200);
      }).catch(function () {});
    }, 2400);
  }

  /* ---------- Chips mittig halten ---------- */
  function chipsZentrieren(weich) {
    var bar = root.querySelector('[data-lrs-chips]');
    var a = bar && bar.querySelector('[aria-current="page"]');
    if (!a) return;
    var li = a.parentNode;
    var x = li.offsetLeft - (bar.clientWidth - li.offsetWidth) / 2;
    bar.scrollTo({ left: Math.max(0, x), behavior: weich && !ruhig ? 'smooth' : 'auto' });
  }

  /* ---------- Wechsel (Chip, Sortierung, Zurück) ---------- */
  function pfad(href) { var u = new URL(href, location.href); return u.pathname.replace(/\/$/, '').toLowerCase(); }
  function melden(t) { var s = root.querySelector('[data-lrs-status]'); if (s) s.textContent = t; }

  function wechseln(href, art) {
    var meins = ++stand;
    root.classList.add('lrs-wechselt');
    /* Chip sofort umschalten – die Antwort des Fingers kommt vor dem Netz */
    var ziel = pfad(href);
    root.querySelectorAll('[data-lrs-chip]').forEach(function (c) {
      if (pfad(c.href) === ziel) c.setAttribute('aria-current', 'page'); else c.removeAttribute('aria-current');
    });
    chipsZentrieren(true);
    var anker = root.querySelector('[data-lrs-anker]');
    if (art !== 'zurueck' && anker && anker.getBoundingClientRect().top < 0) anker.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    var pause = new Promise(function (r) { setTimeout(r, ruhig ? 0 : 200); });
    return Promise.all([holen(href), pause]).then(function (a) {
      if (meins !== stand) return;
      tauschen(a[0]);
      var sauber = new URL(href, location.href); sauber.searchParams.delete('section_id'); sauber.searchParams.delete('preview_theme_id');
      if (art === 'push') history.pushState({ lrs: 1 }, '', sauber.pathname + sauber.search);
      else if (art === 'ersetzen') history.replaceState({ lrs: 1 }, '', sauber.pathname + sauber.search);
      if (root.dataset.titel) document.title = root.dataset.titel;
      root.classList.remove('lrs-wechselt');
      var anz = root.querySelector('[data-lrs-anzahl]');
      melden((root.querySelector('.lrs-h1') || {}).textContent + ': ' + (anz ? anz.textContent : ''));
    }).catch(function () {
      if (meins === stand) location.href = href;
    });
  }

  function tauschen(neu) {
    var alt;
    root.dataset.titel = neu.getAttribute('data-titel') || '';
    root.dataset.handle = neu.getAttribute('data-handle') || '';
    ['[data-lrs-kopf]', '[data-lrs-inhalt]'].forEach(function (sel) {
      var n = neu.querySelector(sel); alt = root.querySelector(sel);
      if (n && alt) alt.replaceWith(document.adoptNode(n));
    });
    /* Chips: bei gleicher Reihe nur den Zustand übernehmen (Scrollstellung bleibt), sonst ersetzen */
    var cn = neu.querySelector('[data-lrs-chips]'), ca = root.querySelector('[data-lrs-chips]');
    if (cn && ca) {
      var ln = [].map.call(cn.querySelectorAll('[data-lrs-chip]'), function (c) { return c.getAttribute('href'); }).join(),
          la = [].map.call(ca.querySelectorAll('[data-lrs-chip]'), function (c) { return c.getAttribute('href'); }).join();
      if (ln !== la) { ca.replaceWith(document.adoptNode(cn)); chipsZentrieren(false); }
      else {
        var cur = cn.querySelector('[aria-current]'), h = cur && cur.getAttribute('href');
        ca.querySelectorAll('[data-lrs-chip]').forEach(function (c) { if (c.getAttribute('href') === h) c.setAttribute('aria-current', 'page'); else c.removeAttribute('aria-current'); });
      }
    }
    beobachten();
  }

  root.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var c = e.target.closest('[data-lrs-chip]');
    if (c) {
      e.preventDefault();
      if (c.getAttribute('aria-current') === 'page' && !root.classList.contains('lrs-wechselt')) return;
      wechseln(c.href, 'push');
      return;
    }
    var m = e.target.closest('[data-lrs-mehr]');
    if (m) { e.preventDefault(); mehr(m); }
  });

  root.addEventListener('change', function (e) {
    var s = e.target.closest('[data-lrs-sortierung]');
    if (!s) return;
    var f = s.form, u = new URL(f.getAttribute('action'), location.href);
    u.searchParams.set('sort_by', s.value);
    wechseln(u.toString(), 'ersetzen');
  });
  root.addEventListener('submit', function (e) {
    if (e.target.matches('[data-lrs-sortform]')) { e.preventDefault(); var s = e.target.querySelector('select'); s.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- Mehr laden ---------- */
  function mehr(a) {
    if (a.classList.contains('laedt')) return;
    a.classList.add('laedt'); a.setAttribute('aria-busy', 'true');
    var t = a.querySelector('span'); var vorher = t ? t.textContent : '';
    if (t) t.textContent = 'Lädt …';
    holen(a.href).then(function (neu) {
      var liste = root.querySelector('[data-lrs-liste]');
      var karten = neu.querySelectorAll('[data-lrs-liste] > .lrs-k');
      var erste = null;
      karten.forEach(function (k) { k.classList.remove('sofort'); var x = document.adoptNode(k); liste.appendChild(x); if (!erste) erste = x; });
      var block = root.querySelector('[data-lrs-mehrblock]'), nb = neu.querySelector('[data-lrs-mehrblock]');
      if (block) { if (nb) block.replaceWith(document.adoptNode(nb)); else block.remove(); }
      beobachten();
      if (erste) { var l = erste.querySelector('a'); if (l) l.focus({ preventScroll: true }); }
      melden(karten.length + ' weitere geladen');
    }).catch(function () { location.href = a.href; })
      .finally(function () { a.classList.remove('laedt'); a.removeAttribute('aria-busy'); if (t) t.textContent = vorher; });
  }

  /* ---------- Zurück/Vor ---------- */
  try { history.replaceState({ lrs: 1 }, '', location.href); } catch (e) {}
  addEventListener('popstate', function (e) {
    if (e.state && e.state.lrs) wechseln(location.href, 'zurueck');
  });

  /* ---------- Start ---------- */
  beobachten();
  chipsZentrieren(false);

  /* Alte Links aus Menü/Startseite: /collections/geschenke?kat=foto */
  var kat = null;
  try { kat = new URLSearchParams(location.search).get('kat'); } catch (e) {}
  var katZiel = { foto: 'foto', poster: 'poster', schmuck: 'schmuck' }[kat];
  if (kat && katZiel && root.dataset.handle === 'geschenke') wechseln('/collections/geschenke/' + katZiel, 'ersetzen');
  else root.classList.remove('lrs-wechselt');
})();
